module.exports = __webpack_public_path__ + "assets/tech-3a067908be3113b4b82f78281b5e2f43.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/Home/assets/tech.jpg
// module id = 637
// module chunks = 0 1